'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.Bonuses = void 0;
var transport_1 = require("../../transport");
var Bonuses = /** @class */ (function () {
    function Bonuses() {
    }
    Bonuses.prototype.credit = function (params) {
        return transport_1.transport.request('bonuses/credit', params);
    };
    return Bonuses;
}());
exports.Bonuses = Bonuses;
